import * as React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import { theme } from './theme';
import { GlobalStyles } from '../styles/globalStyles';

export const ThemeProvider: React.FC = ({ children }) => (
  <StyledThemeProvider theme={theme}>
    <>
      <GlobalStyles />
      {children}
    </>
  </StyledThemeProvider>
);
